import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=130af0a5&scoped=true"
import script from "./AccountInfo.vue?vue&type=script&lang=js"
export * from "./AccountInfo.vue?vue&type=script&lang=js"
import style0 from "./AccountInfo.vue?vue&type=style&index=0&id=130af0a5&prod&scoped=true&lang=css"
import style1 from "./AccountInfo.vue?vue&type=style&index=1&id=130af0a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130af0a5",
  null
  
)

export default component.exports